export const Bio = {
  name: "Prashanth Baithi",
  roles: [
    "Research Associate - AI/ML",
    //"Android Developer",
   // "UI/UX Designer",
    //"Programmer",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/baithiprashanth07",
  resume:
    "https://docs.google.com/document/d/16zrCov5gOhNUkcNKnvITlT6D8cEECk5eXg6Kp5wDec4/edit?usp=drive_link",
  linkedin: "https://www.linkedin.com/in/prashanth-baithi-2b70bb207",
  twitter: "https://x.com/BaithiPrashanth4",
  insta: "https://www.instagram.com/prashanth_baithi/",
  facebook: "https://www.facebook.com/prashanth.baithi.7/",
};

export const skills = [
  {
    title: "Programming Languages",
    skills: [
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "SQL",
        image:
          "https://www.svgrepo.com/show/331760/sql-database-generic.svg",
      },
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
    ],
  },
  {
    title: "Libraries/Frameworks",
    skills: [
      {
        name: "PyTorch",
        image:
          "https://www.vectorlogo.zone/logos/pytorch/pytorch-icon.svg",
      },
      {
        name: "TensorFlow",
        image:
          "https://www.vectorlogo.zone/logos/tensorflow/tensorflow-icon.svg",
      },
      {
        name: "Keras",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ae/Keras_logo.svg/512px-Keras_logo.svg.png",
      },
      {
        name: "OpenCV",
        image:
          "https://opencv.org/wp-content/uploads/2020/07/OpenCV_logo_black_.png",
      },
      {
        name: "Pandas",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/2ae2a900d2f041da66e950e4d48052658d850630/icons/pandas/pandas-original.svg",
      },
      {
        name: "NumPy",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/numpy/numpy-original.svg",
      },
      {
        name: "Seaborn",
        image:
          "https://seaborn.pydata.org/_images/logo-mark-lightbg.svg",
      },
      {
        name: "Matplotlib",
        image:
          "https://matplotlib.org/_static/logo2_compressed.svg",
      },
      {
        name: "LangChain",
        image:
          "https://python.langchain.com/img/brand/wordmark.png",
      },
      {
        name: "Scikit-Learn",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/0/05/Scikit_learn_logo_small.svg",
      },
    ],
  },
  {
    title: "Web Frameworks",
    skills: [
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "Flask",
        image:
          "https://www.vectorlogo.zone/logos/pocoo_flask/pocoo_flask-icon.svg",
      },
      {
        name: "Django",
        image:
          "https://cdn.worldvectorlogo.com/logos/django.svg",
      },
    ],
  },
  {
    title: "Industry Knowledge",
    skills: [
      {
        name: "Machine Learning",
        image:
          "https://cdn-icons-png.flaticon.com/512/8637/8637099.png",
      },
      {
        name: "Deep Learning",
        image:
          "https://cdn-icons-png.flaticon.com/512/4712/4712109.png",
      },
      {
        name: "Data Analytics",
        image:
          "https://cdn-icons-png.flaticon.com/512/2920/2920277.png",
      },
      {
        name: "NLP",
        image:
          "https://cdn-icons-png.flaticon.com/512/1998/1998087.png",
      },
      {
        name: "Gen AI",
        image:
          "https://cdn-icons-png.flaticon.com/512/8637/8637108.png",
      },
      {
        name: "RAG",
        image:
          "https://cdn-icons-png.flaticon.com/512/4968/4968204.png",
      },
      {
        name: "LLMs",
        image:
          "https://cdn-icons-png.flaticon.com/512/4712/4712139.png",
      },
    ],
  },
  {
    title: "Technical Skills",
    skills: [
      {
        name: "Image Processing",
        image:
          "https://cdn-icons-png.flaticon.com/512/2920/2920349.png",
      },
      {
        name: "Feature Extraction",
        image:
          "https://cdn-icons-png.flaticon.com/512/4341/4341134.png",
      },
      {
        name: "Data Visualization",
        image:
          "https://cdn-icons-png.flaticon.com/512/1005/1005141.png",
      },
      {
        name: "Object Detection",
        image:
          "https://cdn-icons-png.flaticon.com/512/4712/4712027.png",
      },
    ],
  },
  {
    title: "Tools and Platforms",
    skills: [
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Power BI",
        image:
          "https://www.vectorlogo.zone/logos/microsoft_powerbi/microsoft_powerbi-icon.svg",
      },
      {
        name: "Tableau",
        image:
          "https://www.vectorlogo.zone/logos/tableau/tableau-icon.svg",
      },
      {
        name: "Google Colab",
        image:
          "https://colab.research.google.com/img/colab_favicon_256px.png",
      },
      {
        name: "Jupyter Notebook",
        image:
          "https://www.vectorlogo.zone/logos/jupyter/jupyter-icon.svg",
      },
      {
        name: "PyCharm",
        image:
          "https://www.vectorlogo.zone/logos/jetbrains/jetbrains-icon.svg",
      },
      {
        name: "Hugging Face",
        image:
          "https://huggingface.co/datasets/huggingface/brand-assets/resolve/main/hf-logo.png",
      },
      {
        name: "Kaggle",
        image:
          "https://www.vectorlogo.zone/logos/kaggle/kaggle-icon.svg",
      },
    ],
  },
  {
    title: "Cloud Platforms",
    skills: [
      {
        name: "Amazon Web Services",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/amazonwebservices/amazonwebservices-original-wordmark.svg",
      },
      {
        name: "Microsoft Azure",
        image:
          "https://www.vectorlogo.zone/logos/microsoft_azure/microsoft_azure-icon.svg",
      },
      {
        name: "Google Cloud",
        image:
          "https://www.vectorlogo.zone/logos/google_cloud/google_cloud-icon.svg",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://upload.wikimedia.org/wikipedia/en/0/0b/IDRBT_logo.png", // Placeholder logo for IDRBT
    role: "Research Associate - AI/ML",
    company: "IDRBT (Affiliated With Reserve Bank of India)",
    date: "May 2022 - June 2024",
    desc: `Worked closely with the IDRBT research team to identify research questions and develop approaches to solve complex problems. 
• Designed and developed a facial expression recognition system using TensorFlow and PyTorch.
• Implemented and evaluated various image augmentation techniques to improve the robustness of the model.
`,
    skills: [
      "Python",
      "Deep Learning",
      "Machine Learning",
      "Computer Vision",
      "NLP", "Gen AI",
      "TensorFlow",
      "PyTorch",
      "Keras",
      "OpenCV",
      "NLTK",
      "Langchain",
    ],
    doc: "", // Add if you have a certificate or presentation link
  },
  {
    id: 1,
    img: "https://cdn-icons-png.flaticon.com/512/2721/2721268.png", // Placeholder icon for hardware
    role: "Intern - Hardware Installation & Maintenance",
    company: "Computer Care",
    date: "Mar 2017 - Jun 2017 (4 months)",
    desc: `Identified and resolved issues with computer hardware components such as hard drives, motherboards, and RAM.`,
    skills: [
      "Hardware Troubleshooting",
      "Operating System Installation",
      "Networking Basics",
      "System Maintenance",
      "Component Replacement",
    ],
    doc: "", // Add a link if there's documentation
  },

];

export const education = [
  {
    id: 0,
    img: "https://upload.wikimedia.org/wikipedia/en/9/99/CMR_Engineering_College_logo.png",
    school: "CMR Engineering College",
    date: "2017 - 2020",
    grade: "CGPA: 7.09/10",
    desc: "I completed my Bachelor's degree in Engineering at CMR Engineering College. The curriculum focused on core technical subjects and provided strong foundational knowledge in engineering principles and practical applications.",
    degree: "Bachelor’s Degree in Engineering",
  },
  {
    id: 1,
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f2/Emblem_of_India.svg/1200px-Emblem_of_India.svg.png",
    school: "Government Polytechnic College",
    date: "2014 - 2017",
    grade: "Percentage: 68.99%",
    desc: "I pursued a Diploma in Engineering at Government Polytechnic College, where I gained practical skills and foundational knowledge in my field.",
    degree: "Diploma in Engineering",
  },
  {
    id: 2,
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/74/Zilla_Parishad_Emblem.png/600px-Zilla_Parishad_Emblem.png",
    school: "Zilla Parishad High School",
    date: "2014",
    grade: "CGPA: 7.0/10",
    desc: "I completed my Class 10th at ZP High School with a focus on core academic subjects and foundational computer skills.",
    degree: "Class 10th (SSC)",
  },
];


export const projects = [
  {
    id: 1,
    title: "Knowledge Distillation Using Facial Expression Recognition",
    date: "Nov 2023 - May 2024",
    description:
      "Implemented Knowledge Distillation (KD) to transfer knowledge from a complex ResNet50 teacher model to smaller, more efficient student models, including lightweight Vision Transformers (ViTs). Proposed a novel KD framework combining feature map and attention map distillation to transfer discriminative features and attention mechanisms crucial for ViTs. Utilized Python for data analytics, including pre-processing, visualization, and performance metrics calculation, to ensure thorough evaluation and analysis of FER models.",
    image:
      "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    tags: ["Python", "PyTorch", "ResNet50", "Vision Transformers", "Knowledge Distillation", "Data Analytics", "Computer Vision"],
    category: "Computer vision",
    github: "https://github.com/baithiprashanth07",
    //webapp: "https://github.com/yourusername/knowledge-distillation-fer",
  },
  {
    id: 2,
    title: "FER using Graph Neural Network (GNN) and Vision Transformers",
    date: "May 2023 - Oct 2023",
    description:
      "Developed a novel approach to improve Facial Expression Recognition (FER) systems by integrating Graph Neural Networks (GNNs) and Visual Transformers (ViTs). Implemented GNNs for low-level feature extraction and representation learning, capturing relationships and dependencies among facial landmarks. Utilized programming languages and tools/frameworks such as Python, Data analysis, and PyTorch for model development, training, and evaluation.",
    image:
      "https://images.unsplash.com/photo-1555255707-c07966088b7b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    tags: ["Python", "PyTorch", "Graph Neural Networks", "Vision Transformers", "Facial Landmarks", "Data Analysis", "Deep Learning"],
    category: "Computer vision",
    github: "https://github.com/baithiprashanth07",
    //webapp: "https://github.com/yourusername/fer-gnn-vit",
  },
  {
    id: 3,
    title: "FER using Lightweight Deformable Multi-scale for Mobile Applications",
    date: "May 2022 - Feb 2023",
    description:
      "Designed and implemented DMSNet, a novel model utilizing architectural elements such as depthwise separable convolution, deformable convolution, and Receptive Field Blocks (RFBs) to extract multi-scale spatial features efficiently. Achieved a balance between model performance and network parameters, improving computational efficiency and suitability for resource-constrained environments. Utilized programming languages and tools/frameworks such as Python, Data analysis, and PyTorch for model development, training, and evaluation.",
    image:
      "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    tags: ["Python", "PyTorch", "DMSNet", "Deformable Convolution", "Mobile Applications", "Deep Learning", "Computer Vision"],
    category: "Computer vision",
    github: "https://github.com/baithiprashanth07",
   // webapp: "https://github.com/yourusername/dmsnet-mobile-fer",
  },
  {
    id: 4,
    title: "Multi-Agent Architecture for AI/GenAI Use Case Generation",
    date: "2024",
    description:
      "Designed a comprehensive multi-agent system that generates industry-specific AI and GenAI use cases for businesses, utilizing specialized agents for research, analysis, and recommendation synthesis. Implemented a modular architecture with four interconnected agents powered by large language models to deliver actionable AI implementation strategies with supporting datasets and resources. Leveraged Langchain framework with Python to orchestrate complex agent workflows, incorporating web search capabilities and LLM reasoning to produce highly relevant, feasible use case proposals tailored to company objectives.",
    image:
      "https://images.unsplash.com/photo-1677442136019-21780ecad995?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    tags: ["Python", "LangChain", "Claude 3.7 Sonnet", "GPT-4", "Streamlit", "Multi-Agent Systems", "GenAI", "Jupyter Notebooks"],
    category: "Gen AI",
    github: "https://github.com/baithiprashanth07",
   // webapp: "https://your-streamlit-app.streamlit.app",
  },
];

export const TimeLineData = [
  { year: 2022, text: "Started my journey" },
  { year: 2022, text: "Worked as a Research Associate" },

  { year: 2024, text: "Worked as a freelance developer" },
  //{ year: 2019, text: "Founded JavaScript Mastery" },
 // { year: 2020, text: "Shared my projects with the world" },
  //{ year: 2021, text: "Started my own platform" },
];
